import React from 'react';
import { bookingShape, historyDetailShape } from 'constants/propTypes';

import PropTypes from 'prop-types';
import { ActionItemPassenger, ActionItemPassengerCell } from './HistoryDetail.styles';
import PassengerType from '../../../../../../components/ui/PassengerType';
import HistoryActionPassengerId from './HistoryActionPassengerId';
import { getBookingPassengerByUuid } from './HistoryDetails.utils';

const HistoryActionPassenger = ({ action, booking, detail }) => {
  const getName = (passenger) => {
    const { isCompany, firstName, lastName } = passenger;
    if (isCompany) {
      return firstName ?? '-';
    }

    return firstName || lastName ? `${firstName ?? ''} ${lastName ?? ''}` : '-';
  };

  const getPaxType = (passenger) => {
    const { type, disabilityType } = passenger;

    return {
      type,
      disabilityType
    };
  };

  return (
    <ActionItemPassenger>
      {detail.data.passengers
        .filter((p) => detail.revisionContents[action].includes(p.uuid))
        .map((p) => {
          const passenger = { ...p, ...getBookingPassengerByUuid(booking, p.uuid) };

          return (
            <React.Fragment key={p.uuid}>
              <ActionItemPassengerCell>
                <HistoryActionPassengerId passenger={passenger} />
              </ActionItemPassengerCell>
              <ActionItemPassengerCell>{`${getName(p)}`}</ActionItemPassengerCell>
              <ActionItemPassengerCell>
                <PassengerType {...getPaxType(p)} />
              </ActionItemPassengerCell>
            </React.Fragment>
          );
        })}
    </ActionItemPassenger>
  );
};

HistoryActionPassenger.propTypes = {
  action: PropTypes.string.isRequired,
  booking: bookingShape,
  detail: historyDetailShape.isRequired
};

export default HistoryActionPassenger;
